import { STORAGE_BOX_COLOR_TAGS, STORAGE_BOX_COLOR_HEX } from '../constants';

export function colorTagHex(colorTag) {
  if (!colorTag) return null;
  return STORAGE_BOX_COLOR_HEX[colorTag] || null;
}

export function normalizeItemMeta(item) {
  if (!item) return item;
  return {
    ...item,
    isFavorite: Boolean(item.isFavorite),
    colorTag: item.colorTag ? String(item.colorTag) : '',
    tagLabel: item.tagLabel ? String(item.tagLabel).trim() : '',
    folderColor: item.folderColor ? String(item.folderColor) : '',
  };
}

export function colorTagDisplayName(colorTag) {
  if (!colorTag) return '';
  const found = STORAGE_BOX_COLOR_TAGS.find((t) => t.id === colorTag);
  return found?.label || colorTag;
}

export function itemHasMeta(item) {
  if (!item) return false;
  return Boolean(item.isFavorite || item.colorTag || item.tagLabel);
}

/** Human-readable meta line, e.g. "Favorite · Red · Project files" */
export function itemMetaSummaryParts(item) {
  const parts = [];
  if (item?.isFavorite) parts.push('Favourite');
  if (item?.colorTag) {
    parts.push(`Colour: ${colorTagDisplayName(item.colorTag)}`);
  }
  if (item?.tagLabel) {
    parts.push(`Label: ${item.tagLabel}`);
  }
  return parts;
}

export function itemMetaSummaryText(item) {
  return itemMetaSummaryParts(item).join(' · ');
}
